// @material-ui/core
import { AppBar, IconButton, Toolbar, Typography } from "@material-ui/core";
// @material-ui/styles
import { withStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Menu as MenuIcon } from "@material-ui/icons";
// theme
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ShowLocation from "../library/helper/ShowLocation";
// custom
import Caba from "../services/Caba";
import MainBarMenu from "./MainBarMenu";
// import LogoLoader from "./LogoLoader";
import Profile from "./Profile";

const drawerWidth = 240;
const styles = theme => ({
  appBar: {
    width: `100%`,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - 9 * ${theme.spacing.unit}px)`
    },
    // zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth
    },
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    color: "rgba(255,255,255,0.6)"
  },
  hide: {
    display: "none"
  },
  flex: {
    flex: 1,
    textTransform: "capitalize"
  },
  title: {
    marginRight: theme.spacing.unit,
    marginLeft: 3 * theme.spacing.unit,
    color: "rgba(255,255,255,0.6)",
    fontWeight: "bold",
    fontSize: 1.2 * theme.typography.fontSize
  },
  menuItem: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& $primary, & $icon": {
        color: theme.palette.common.white
      },
      outline: "none"
    }
  },
  primary: {},
  icon: {},
  noOutline: {
    "&:focus": {
      outline: "none"
    }
  }
});

class MainBar extends Component {
  state = {
    loggedIn: false,
    profile: Caba.getProfile(),
    anchorEl: null
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes } = this.props;
    const { profile } = this.state;

    return (
      <AppBar
        className={classNames(
          classes.appBar,
          this.props.open && classes.appBarShift
        )}>
        <Toolbar
          disableGutters={true}
          classes={{
            gutters: classes.appBarGutters
          }}>
          <IconButton
            aria-label="open drawer"
            onClick={this.props.handleOpen}
            className={classNames(
              classes.menuButton,
              !this.props.isAutoClose && classes.hide
            )}>
            <MenuIcon />
          </IconButton>
          {/* {this.props.open && (
            <LogoLoader fill="#000" loading={this.props.isLoading} />
          )} */}
          <Typography
            type="body1"
            color="inherit"
            noWrap
            className={classes.title}>
            Caba
          </Typography>
          <ShowLocation className={classes.flex} />
          <Profile profile={profile} />

          <MainBarMenu />
        </Toolbar>
      </AppBar>
    );
  }
}

MainBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired
};

export default withStyles(styles, { withTheme: true })(MainBar);



// WEBPACK FOOTER //
// ./src/appBar/MainBar.js